import {
    fetchAdmin,
    fetchAppUsers,
    fetchBoUsers,
    fetchPaymentDefaultUsers,
    fetchStudentUsers,
    fetchUser,
    getPushTokenStatus,
} from '../queries/users.queries';

import { useQuery } from '@tanstack/react-query';

export const useAppUsers = () => {
    return useQuery({
        queryKey: ['app-users'],
        queryFn: fetchAppUsers,
    });
};

export const useBoUsers = () => {
    return useQuery({
        queryKey: ['bo-users'],
        queryFn: fetchBoUsers,
    });
};

export const useUser = (userId: number) => {
    return useQuery({
        queryKey: ['user', userId],
        queryFn: () => fetchUser(userId),
    });
};

export const useAdmin = (adminId: number) => {
    return useQuery({
        queryKey: ['admin', adminId],
        queryFn: () => fetchAdmin(adminId),
    });
};

export const usePaymentDefaultUsers = () => {
    return useQuery({
        queryKey: ['payment-default-users'],
        queryFn: fetchPaymentDefaultUsers,
    });
};

export const useStudentUsers = () => {
    return useQuery({
        queryKey: ['student-users'],
        queryFn: fetchStudentUsers,
    });
};

export const usePushTokenStatus = () => {
    return useQuery<boolean, Error>({
        queryKey: ['push-token-status'],
        queryFn: async () => {
            const data = await getPushTokenStatus();
            return data;
        },
    });
};
